import React from 'react';
import { MapPin, Clock, ArrowRight, Briefcase, Search } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { jobListings } from '../data/mock';

const Careers = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="careers" className="py-24 bg-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-shsTeal/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-shsGold/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left Column - Content */}
          <div>
            <span className="inline-block px-4 py-1 bg-shsTeal/10 text-shsTeal rounded-full text-sm font-medium mb-4">
              Careers
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-shsNavy mb-6">
              Join Our
              <span className="text-shsTeal"> Growing Team</span>
            </h2>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              We're always looking for passionate hospitality professionals who share
              our commitment to excellence. Discover exciting career opportunities
              across Australia's finest properties.
            </p>

            {/* Benefits */}
            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              {[
                'Competitive Pay',
                'Flexible Hours',
                'Career Growth',
                'Training Programs',
                'Premium Locations',
                'Supportive Team'
              ].map((benefit, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 p-3 bg-slate-50 rounded-xl"
                >
                  <div className="w-8 h-8 bg-shsTeal/10 rounded-lg flex items-center justify-center">
                    <Briefcase className="w-4 h-4 text-shsTeal" />
                  </div>
                  <span className="font-medium text-shsNavy">{benefit}</span>
                </div>
              ))}
            </div>

            <Button
              onClick={scrollToContact}
              className="bg-shsTeal hover:bg-shsBlue text-white px-8 py-6 rounded-full text-lg font-semibold transition-all duration-300 hover:shadow-xl hover:shadow-shsTeal/20 group"
            >
              Submit Your Resume
              <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
            </Button>
          </div>

          {/* Right Column - Job Listings */}
          <div>
            {/* Search Box */}
            <div className="bg-slate-50 rounded-2xl p-6 mb-6">
              <div className="flex gap-4">
                <div className="flex-1 relative">
                  <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                  <Input
                    placeholder="Search positions..."
                    className="pl-12 py-6 rounded-xl border-gray-200 focus:border-shsTeal focus:ring-shsTeal"
                  />
                </div>
                <Button className="bg-shsNavy hover:bg-shsBlue px-6 rounded-xl">
                  Search
                </Button>
              </div>
            </div>

            {/* Job Cards */}
            <div className="space-y-4">
              {jobListings.map((job) => (
                <div
                  key={job.id}
                  className="group bg-white border border-gray-100 rounded-2xl p-6 hover:shadow-xl hover:shadow-shsTeal/10 hover:border-shsTeal/20 transition-all duration-300 cursor-pointer"
                >
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <h3 className="text-xl font-semibold text-shsNavy group-hover:text-shsTeal transition-colors">
                        {job.title}
                      </h3>
                      <p className="text-gray-600">{job.description}</p>
                    </div>
                    <ArrowRight className="w-5 h-5 text-gray-300 group-hover:text-shsTeal group-hover:translate-x-1 transition-all" />
                  </div>

                  <div className="flex flex-wrap gap-4 text-sm">
                    <div className="flex items-center gap-2 text-gray-500">
                      <MapPin className="w-4 h-4" />
                      <span>{job.location}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-500">
                      <Clock className="w-4 h-4" />
                      <span>{job.type}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* View All Link */}
            <div className="text-center mt-6">
              <button className="text-shsTeal font-medium hover:text-shsBlue transition-colors inline-flex items-center gap-2">
                View All Positions
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Careers;
